<template>
    <section class="acessorios-module">
        <!-- Loading -->
        <loading />

        <div class="icon-text-wrapper mb-tablet-only">
            <p @click="showSidebarMenu()" role="button" class="turnback">
                Menu
            </p>
        </div>

        <!-- Module Actions -->
        <module-action
            :csrftolken="csrftolken"
            :alldata="moduledata"
            @dynamic-data="getDynamicDataFromModuleAction($event)"
            :orderurl="moduleorder"
            :searchurl="modulesearch"
            classname="acessorios-module-action"
            :idname="`${modulename}_header`"
            :modulename="`${modulename}`"
            searchplaceholder="search by id or name"
            :createlink="modulecreate"
            subheaderstring="Cria e gere os teus acessórios"
            mobileindicatename="accessoriescreate"
        >
            <template #custom_action> </template>
        </module-action>

        <!-- Content -->
        <template v-if="Object.values(allData).length > 0">
            <div class="table-scroll-wrapper desktop-only">
                <!-- Page List Render-->
                <table-element
                    :classname="['table-striped', 'acessorios-content-table']"
                >
                    <!-- THead -->
                    <template #thead>
                        <tr>
                            <th scope="col">
                                <div class="id-header">
                                    <p
                                        class="color-text-body strong-400"
                                        style="border: none"
                                    >
                                        ID
                                    </p>
                                </div>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">Icon</p>
                            </th>

                            <th scope="col">
                                <p class="strong-600 color-text-body">Nome</p>
                            </th>

                            <th scope="col">
                                <p class="strong-600 color-text-body">
                                    Descrição
                                </p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Criado em:
                                </p>
                            </th>

                            <th scope="col">
                                <p class="color-text-body strong-400">
                                    Última edição
                                </p>
                            </th>

                            <th scope="col">
                                <div class="action-header">
                                    <p class="color-text-body strong-400">
                                        Ações
                                    </p>
                                </div>
                            </th>
                        </tr>
                    </template>

                    <!-- Tbody -->
                    <template #tbody>
                        <tr
                            v-for="(value, index) in allData"
                            :key="value.id"
                            :data-referindex="index"
                            :data-id="value.id"
                        >
                            <th scope="row">
                                <div class="same-height id-body">
                                    <p class="strong-400">
                                        {{ value.id }}
                                    </p>
                                </div>
                            </th>

                            <td>
                                <img :src="`${iconimgpath}/${value.data.icon}.svg`" :alt="value.data.name" />
                            </td>

                            <td>
                                <p class="strong-600 same-height">
                                    {{ value.name }}
                                </p>
                            </td>

                            <td class="multiple-words-wrapper">
                                <div class="multiple-words-width">
                                    <p class="strong-400">
                                        {{
                                            value.description !== null
                                                ? resumeMessage(
                                                      value.description,
                                                      100,
                                                      3
                                                  )
                                                : ""
                                        }}
                                    </p>
                                </div>
                            </td>

                            <td>
                                <p class="strong-400 same-height">
                                    {{ value.created_at }}
                                </p>
                            </td>

                            <td>
                                <p class="strong-400 same-height">
                                    {{ value.updated_at }}
                                </p>
                            </td>

                            <td>
                                <div class="same-height buttons-wrapper">
                                    <button
                                        type="button"
                                        class="btn-edit btnedit"
                                        :data-referindex="index"
                                        :data-id="value.id"
                                        data-action="edit"
                                        data-mobileindicate="accessoriesshow"
                                        @click="buttonActions($event)"
                                    >
                                        <span
                                            data-mobileindicate="accessoriesshow"
                                            class="content-icon"
                                            >Editar</span
                                        >
                                    </button>

                                    <button
                                        type="button"
                                        class="btn-remove btnremove"
                                        :data-referindex="index"
                                        :data-id="value.id"
                                        data-action="remove"
                                        @click="buttonActions($event)"
                                    >
                                        <span class="content-icon"
                                            >Remover</span
                                        >
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </template>
                </table-element>
            </div>

            <!-- Mobile Card List Render -->
            <div class="acessorios-mobile-section mobile-only">
                <template v-for="(value, index) in allData" :key="value.id">
                    <card-element
                        classname="acessorios"
                        :index="index"
                        :id="value.id"
                    >
                        <template #cardheadercontent>
                            <div class="header-text-content">
                                <div class="flex-items">
                                    <div class="icon-svg-wrapper">icon.svg</div>

                                    <div class="body-1 strong-600">
                                        {{ value.name }}
                                    </div>
                                </div>

                                <div class="caption-lg color-text-body">
                                    <span class="color-text-action caption-lg"
                                        >ID:
                                    </span>
                                    {{ value.id }}
                                </div>
                            </div>
                            <div class="header-buttons-content">
                                <button
                                    type="button"
                                    class="btn-edit btnedit"
                                    :data-referindex="index"
                                    :data-id="value.id"
                                    data-action="edit"
                                    data-mobileindicate="accessoriesshow"
                                    @click="buttonActions($event)"
                                >
                                    <span
                                        data-mobileindicate="accessoriesshow"
                                        class="content-icon"
                                        >Editar</span
                                    >
                                </button>

                                <button
                                    type="button"
                                    class="btn-remove btnremove"
                                    :data-referindex="index"
                                    :data-id="value.id"
                                    data-action="remove"
                                    @click="buttonActions($event)"
                                >
                                    <span class="content-icon">Remover</span>
                                </button>
                            </div>
                        </template>

                        <template #cardbodycontent>
                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">
                                    Criado em:
                                </p>
                                <p class="black overflow-elipse">
                                    {{ value.created_at }}
                                </p>
                            </div>

                            <div class="item-wrapper">
                                <p class="color-text-body caption-lg">
                                    Ultima edição:
                                </p>
                                <p class="black overflow-elipse">
                                    {{ value.updated_at }}
                                </p>
                            </div>
                        </template>
                    </card-element>
                </template>
            </div>

            <!-- Pagination active -->
            <pagination
                :totalpages="parseInt(totalpages)"
                :firstpageurl="firstpage"
                :otherpagesurl="filePageUrl"
                :modulename="modulename"
            />
        </template>

        <!-- Back To Top -->
        <back-to-top :idhref="`${modulename}_header`" />

        <!-- Response Messages -->
        <div
            @click="closeMessageBox($event)"
            class="responsebasemessage"
            ref="responsebasemessage"
        >
            <list-message />
        </div>
    </section>
</template>

<script>
import fetchData from "../../../fetchData";
import ListMessage from "./../../elements/ListMessageElement.vue";
import Loading from "./../../elements/LoadingElement.vue";
import Table from "./../../elements/TableElement.vue";
import Pagination from "./../../elements/PaginationElement.vue";
import BackToTop from "./../../elements/BackToTopElement.vue";
import ModuleAction from "./../../elements/ModuleActionElementNew.vue";
import Modal from "./../../elements/ModalElement.vue";
import defaultWebsite from "./../../../defaultWebsiteScript.js";
import CardElement from "./../../elements/CardElement.vue";
import responseMessage from "./../../../responseMessage.js";

("use strict");

export default {
    name: "AccessorieAdmin",
    props: {
        csrftolken: {
            type: String,
            required: true,
        },
        moduledata: {
            type: String,
            required: true,
        },
        adminurl: {
            type: String,
            required: true,
        },
        modulesearch: {
            type: String,
            required: true,
        },
        moduleorder: {
            type: String,
            required: true,
        },
        modulefilter: {
            type: String,
            required: true,
        },
        modulecreate: {
            type: String,
            required: true,
        },
        moduleremove: {
            type: String,
            required: true,
        },
        totalpages: {
            type: String,
            required: true,
        },
        firstpage: {
            type: String,
            required: true,
        },
        modulename: {
            type: String,
            required: true,
        },
        moduleurlbase: {
            type: String,
            required: true,
        },
        iconimgpath:{
            type: String,
            required: true,
        }
    },
    data: () => {
        return {
            allData: {},
            moduleshow: "",
            modaltitle: "",
            modaldescription: "",
            modaloptions: {},
            activeclass: "d-flex",
            filePageUrl: "",
            responseTimeOut: 5000,
        };
    },
    created() {
        //Set Review Data
        this.allData = JSON.parse(this.moduledata);

        //Set Review Form Show Url
        this.moduleshow = this.adminurl + `${this.moduleurlbase}/show=`;

        //Set Review Page Url
        this.filePageUrl = this.firstpage + "/page=";
    },
    mounted() {
        window.addEventListener("DOMContentLoaded", function () {
            defaultWebsite.primaryContentConditional(window.screen.width);
        });
    },
    methods: {
        closeMessageBox(element) {
            responseMessage.closeBox(element.target);
        },
        showSidebarMenu() {
            defaultWebsite.showSidebarMenu();
        },
        resumeMessage(text, limit, divisor) {
            //console.log(text);
            if (text !== undefined) {
                let resume =
                    text.length > limit
                        ? `${text.substr(
                              0,
                              Math.round(text.length / divisor)
                          )}...`
                        : text;

                return resume;
            }
        },
        getDynamicDataFromModuleAction(dynamicData) {
            //Set Dynamic Data when clean search input
            if (
                dynamicData !== undefined &&
                typeof dynamicData === "object" &&
                Object.values(dynamicData).length > 0
            ) {
                //Get Default Module Data
                this.allData = dynamicData;
            }
        },
        buttonActions(element) {
            //Get Data for Button Action
            let id = element.currentTarget.getAttribute("data-id");
            //let referindex = element.currentTarget.getAttribute('data-referindex');
            let action = element.currentTarget.getAttribute("data-action");

            //Set Action bu button
            switch (action) {
                //Edit
                case "edit":
                    //window.location.replace(this.moduleshow + id);

                    defaultWebsite.primarySidebarConditional(
                        element,
                        "mobileconditional",
                        id
                    );

                    break;

                //Remove
                case "remove":
                    //Data Form
                    let dataForm = {
                        id: id,
                        action: action,
                    };

                    //Remove routine
                    this.removeData(dataForm);

                    break;
            }
        },

        showModal(element, classname) {
            //Set Modal Data
            this.modaltitle = element.name;
            this.modaldescription = element.description;
            this.modaloptions = element.options;

            //Show Modal
            $(`.${classname}`).modal("show");

            return;
        },
        hideModal(classname) {
            //Hide Modal
            $(`.${classname}`).modal("hide");

            return;
        },
        removeData(data) {
            //Disabled Button
            document
                .querySelector(`.btn${data.action}`)
                .setAttribute("disabled", true);

            //Confirm Message
            let confirmMessage = `Favor confirmar a exclusão do user de id nº ${data.id} ?`;

            //Confirm Remove
            let confirmRemove = confirm(confirmMessage);

            if (!confirmRemove) {
                //Enabled Button
                document
                    .querySelector(`.btn${data.action}`)
                    .removeAttribute("disabled");

                return;
            }

            //Active Loading
            document.querySelector(".loadingbase").classList.add("d-flex");

            //Send Data
            let response = fetchData.structureTosendData(
                this.moduleremove,
                data,
                this.csrftolken,
                "DELETE"
            );

            //Check Promisse
            response
                .then((value) => {
                    //Enabled Button
                    document
                        .querySelector(`.btn${data.action}`)
                        .removeAttribute("disabled");

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    //Render Response Message
                    responseMessage.renderResponseMessages(
                        this.$refs.responsebasemessage,
                        value.classname,
                        value.message,
                        this.activeclass,
                        this.responseTimeOut
                    );

                    //Set Att Data
                    if (value.hasOwnProperty("attData")) {
                        //Get Module Data
                        this.allData = value.attData;
                    }
                })
                .catch((error) => {
                    //Enabled Button
                    document
                        .querySelector(`.btn${data.action}`)
                        .removeAttribute("disabled");

                    //Desactive Loading
                    document
                        .querySelector(".loadingbase")
                        .classList.remove("d-flex");

                    throw new Error(error);
                });
        },
    },
    computed: {
        computedAllData() {
            return this.allData;
        },
    },
    watch: {
        computedAllData() {},
    },
    components: {
        listMessage: ListMessage,
        loading: Loading,
        tableElement: Table,
        pagination: Pagination,
        backToTop: BackToTop,
        moduleAction: ModuleAction,
        modal: Modal,
        cardElement: CardElement,
    },
};
</script>
